import { CommunityList, EventsList, TournamentsList } from '../components'
import { FormattedMessage } from 'react-intl'
import React from 'react'

const getMonthDateRange = (year, monthIndex) => {
  const firstDay = new Date(Date.UTC(year, monthIndex, 1))
  const lastDay = new Date(Date.UTC(year, monthIndex + 1, 0))

  const formatDate = date => {
    const year = date.getUTCFullYear()
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const day = String(date.getUTCDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  return {
    startedFromDate: formatDate(firstDay),
    startedToDate: formatDate(lastDay),
  }
}

const year = new Date().getFullYear()

export const MENU_TABS = [
  {
    id: '0',
    title: 'navigation.community',
    route: '/calendar/community',
    components: () => <CommunityList />,
  },
  {
    id: '1',
    title: 'calendar.events',
    route: '/calendar/events',
    components: () => <EventsList />,
  },
  {
    id: '2',
    title: 'calendar.tournaments',
    route: '/calendar/tournaments',
    components: () => <TournamentsList />,
  },
]

export const MONTHS_LIST = [
  {
    id: `${year}-01`,
    value: <FormattedMessage id='calendar.filter.month.jan' />,
    month: `${year}-01`,
    ...getMonthDateRange(year, 0), // January
  },
  {
    id: `${year}-02`,
    value: <FormattedMessage id='calendar.filter.month.feb' />,
    month: `${year}-02`,
    ...getMonthDateRange(year, 1), // February
  },
  {
    id: `${year}-03`,
    value: <FormattedMessage id='calendar.filter.month.march' />,
    month: `${year}-03`,
    ...getMonthDateRange(year, 2), // March
  },
  {
    id: `${year}-04`,
    value: <FormattedMessage id='calendar.filter.month.apr' />,
    month: `${year}-04`,
    ...getMonthDateRange(year, 3), // April
  },
  {
    id: `${year}-05`,
    value: <FormattedMessage id='calendar.filter.month.may' />,
    month: `${year}-05`,
    ...getMonthDateRange(year, 4), // May
  },
  {
    id: `${year}-06`,
    value: <FormattedMessage id='calendar.filter.month.jun' />,
    month: `${year}-06`,
    ...getMonthDateRange(year, 5), // June
  },
  {
    id: `${year}-07`,
    value: <FormattedMessage id='calendar.filter.month.jul' />,
    month: `${year}-07`,
    ...getMonthDateRange(year, 6), // July
  },
  {
    id: `${year}-08`,
    value: <FormattedMessage id='calendar.filter.month.aug' />,
    month: `${year}-08`,
    ...getMonthDateRange(year, 7), // August
  },
  {
    id: `${year}-09`,
    value: <FormattedMessage id='calendar.filter.month.sep' />,
    month: `${year}-09`,
    ...getMonthDateRange(year, 8), // September
  },
  {
    id: `${year}-10`,
    value: <FormattedMessage id='calendar.filter.month.oct' />,
    month: `${year}-10`,
    ...getMonthDateRange(year, 9), // October
  },
  {
    id: `${year}-11`,
    value: <FormattedMessage id='calendar.filter.month.nov' />,
    month: `${year}-11`,
    ...getMonthDateRange(year, 10), // November
  },
  {
    id: `${year}-12`,
    value: <FormattedMessage id='calendar.filter.month.dec' />,
    month: `${year}-12`,
    ...getMonthDateRange(year, 11), // December
  },
]
